/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfacebooktitle2Inputs */

const en_crosspostingfacebooktitle2 = /** @type {(inputs: Crosspostingfacebooktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post to Facebook`)
};

const de_crosspostingfacebooktitle2 = /** @type {(inputs: Crosspostingfacebooktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Facebook posten`)
};

/**
* | output |
* | --- |
* | "Post to Facebook" |
*
* @param {Crosspostingfacebooktitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfacebooktitle2 = /** @type {((inputs?: Crosspostingfacebooktitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfacebooktitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfacebooktitle2(inputs)
	return de_crosspostingfacebooktitle2(inputs)
});
export { crosspostingfacebooktitle2 as "crosspostingFacebookTitle" }